import React from "react";
import { OpcAssistantIcon } from "../../_shared/OpcChatView/OpcChatView";
import { AppMarkdown } from "../../../../shared/AppMarkdown/AppMarkdown";
import { progressValue } from "../../_config/okrPlansCoachConfig";

// ═══════════════════════════════════════════════════════════════════════════
// A card from the owner's chat, read-only (CD25): its message is the card
// JSON in its final state (BE D106). The agent bubble with the card's text,
// any change rows (current → proposed) and how it ended — no buttons.
// ═══════════════════════════════════════════════════════════════════════════

const OUTCOME = {
  APPLIED: "Updated",
  PARTIAL: "Partly updated",
  CANCELLED: "Not applied",
  SUBMITTED: "Review submitted",
  DISMISSED: "Not applied",
  SAVED: "Saved",
  EXPIRED: "Replaced by a newer card",
};

export const parseOwnerCard = (message) => {
  if (!message || typeof message.message !== "string") return null;
  try {
    const card = JSON.parse(message.message);
    return card && typeof card === "object" ? card : null;
  } catch {
    return null;
  }
};

const OwnerCard = ({ card }) => {
  const items = card.items || card.summary?.key_results || [];
  return (
    <div className="cp-message-row cp-message-row--assistant d-flex align-items-start w-100">
      <OpcAssistantIcon />
      <div className="cp-bubble-wrap">
        <div className="cp-bubble cp-bubble--assistant">
          {card.text ? <AppMarkdown>{card.text}</AppMarkdown> : null}
          {items.map((it, i) => (
            <div
              key={it.item_id || it.key_result_id || i}
              className="d-flex align-items-center justify-content-between key-result-item pb-1 mt-2"
            >
              <span className="small dark-grey">
                {it.label || it.statement}
              </span>
              <span className="small fw-bold dark-grey ms-3">
                {it.proposed != null
                  ? `${progressValue(it, it.current)} → ${progressValue(it, it.proposed)}`
                  : `${it.progress ?? 0}%`}
              </span>
            </div>
          ))}
          {OUTCOME[card.status] ? (
            <div className="review-completed d-inline-flex align-items-center mt-3">
              <img
                src="/assets/images/true-sucess.svg"
                className="me-1"
                alt=""
              />
              {OUTCOME[card.status]}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default OwnerCard;
